/* eslint-disable */
import { createApp } from 'vue'
import App from './App.vue'
import '@fontsource/poppins' // Defaults to weight 400.
import "@fontsource/poppins"; // Defaults to weight 400.
import "@fontsource/poppins/700.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/500.css";

document.title = 'Bewo Cutting Wizard';

createApp(App).mount('#app')
